import apiConfig from "src/utils/apiConfig";

export const FETCH_HISTORY = "history/fetchHistoryRequest";
export const UPDATE_HISTORY = "history/updateHistoryRequest";

export const fetchHistory = (
  fromdate: string,
  todate: string,
  filter?: string,
  limit?: number,
  skip?: number
) => {
  let endpoint = `${apiConfig.VEHICALEHISTORY}/?fromdate=${fromdate}&todate=${todate}`;

  if (filter && filter.trim() !== "") {
    endpoint += `&filter=${encodeURIComponent(filter.trim())}`;
  }
  if (limit !== undefined) {
    endpoint += `&limit=${limit}`;
  }
  if (skip !== undefined) {
    endpoint += `&skip=${skip}`;
  }

  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: FETCH_HISTORY,
    payload: apiobject,
  };
};

export const updateHistory = (payload: any) => {
  const apiObject: any = {
    method: 'POST',
    authentication: true,
    endpoint: apiConfig.UPDATEHISTORY,
    body: payload,
  };
  return {
    type: UPDATE_HISTORY,
    payload: apiObject,
  };
};
